import DateFormatUtil, {DatetimeFormatUtil} from "./DateFormatUtil";

const LuckyNumberFormatUtil = (x) => {
    x = x.toString();
    var pattern = /(-?\d+)(\d{3})/;
    while (pattern.test(x)) {
        x = x.replace(pattern, "$1.$2");
    } 
    
    return x;
}

export const PromoEndDateFormat = (evaluteEndDate, daysToParticipate) => {
    let dateInfo = DateFormatUtil(evaluteEndDate || '');
    let hourInfo = DatetimeFormatUtil(evaluteEndDate || '',{hour: '2-digit', minute:'2-digit'});
    if(daysToParticipate === 1) {
        dateInfo = `amanhã às ${hourInfo}`;
    } else if(daysToParticipate === 0) {
        dateInfo = `hoje às ${hourInfo}`
    }

    return dateInfo;
}

export default LuckyNumberFormatUtil;